import { CreateColumn } from '../../../../Services/agGrid/createColumn';
import PassOrDateCellEditor from '../../../../Components/AgGrid/PassOrDateCellEditor';
import dayjs from 'dayjs';

/**
 * 작업환경측정 그리드 컬럼 정의 (공정명, 측정주기 연도별 상/하반기, 비고)
 * - 기준년도(baseYear) 기준 4개년도: baseYear-2, baseYear-1, baseYear, baseYear+1
 * @param {object} props - gridRef1, rowData1, ..., baseYear(선택, 기준년도)
 * @returns {Array} 컬럼 정의 배열
 */
export const getColumnDefs1 = (props) => {
  // 기준년도(baseYear) 기준 4개년도: baseYear-2, baseYear-1, baseYear, baseYear+1
  const baseYear = parseInt(props.baseYear, 10) || dayjs().year();
  const year1 = baseYear - 2;
  const year2 = baseYear - 1;
  const year3 = baseYear;
  const year4 = baseYear + 1;

  // 상반기/하반기 셀 정의 (PASS/날짜 콤보)
  const halfYearColumn = (field, headerName) =>
    CreateColumn(field, headerName, 'center', 130, true, false, false, 'text', {
      minWidth: 120,
      cellEditor: PassOrDateCellEditor,
      valueFormatter: (params) => {
        const v = params.value;
        if (!v) return '';
        if (v === 'PASS') return 'PASS';
        if (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}/.test(v)) {
          return dayjs(v).isValid() ? dayjs(v).format('YYYY-MM-DD') : v;
        }
        return v;
      },
    });

  // 컬럼 정의 배열
  return [
    // 공정코드: 저장(SaveWorBasicU2) 시 필수, 그리드에는 숨김으로 유지
    CreateColumn('gongJongCd', '공정코드', 'left', 80, false, false, true, 'text'),

    CreateColumn('gongJongNm', '공정명', 'center', 120, false, true, false, 'text', {
      flex: 1,
      minWidth: 100,
      cellClassRules: {
        'required-cell': (params) =>
          !params.value || (typeof params.value === 'string' && params.value.trim() === ''),
      },
      // 수정불가 컬럼: 회색 배경 + not-allowed + 중앙정렬
      customCellStyle: () => ({
        cursor: 'not-allowed',
        backgroundColor: '#f5f5f5',
        color: '#666',
        textAlign: 'center',
      }),
    }),

    {
      headerName: '측정 주기',
      headerClass: 'header-align-center',
      children: [
        { headerName: `${year1}년`, headerClass: 'header-align-center', children: [ halfYearColumn('year1FirstHalf', '상반기'), halfYearColumn('year1SecondHalf', '하반기') ] },
        { headerName: `${year2}년`, headerClass: 'header-align-center', children: [ halfYearColumn('year2FirstHalf', '상반기'), halfYearColumn('year2SecondHalf', '하반기') ] },
        { headerName: `${year3}년`, headerClass: 'header-align-center', children: [ halfYearColumn('year3FirstHalf', '상반기'), halfYearColumn('year3SecondHalf', '하반기') ] },
        { headerName: `${year4}년`, headerClass: 'header-align-center', children: [ halfYearColumn('year4FirstHalf', '상반기'), halfYearColumn('year4SecondHalf', '하반기') ] },
      ],
    },

    CreateColumn('remark', '비고', 'left', 120, true, false, false, 'text', {
      flex: 1,
      minWidth: 100,
    }),
  ];
};

const columnDefs = {
  getColumnDefs1,
};

export default columnDefs;
